import baseFetch, { doFetchWithOptions } from '../baseFetch';

export const fetchUserDetails = () => baseFetch('user');

export const fetchUserEntitlements = () => baseFetch('entitlements');

export const createUserFavorite = favorite => doFetchWithOptions('favorites', {
  method: 'POST',
  body: JSON.stringify(favorite),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const fetchUserFavorites = userDetails => baseFetch('favorites', userDetails);

export const updateUserFavorite = (favoriteId, data, userDetails) => baseFetch(`favorites/${favoriteId}`, userDetails, {
  method: 'PUT',
  body: JSON.stringify(data),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const updateUserFavorites = (data, userDetails) => baseFetch('favorites', userDetails, {
  method: 'PUT',
  body: JSON.stringify(data),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const fetchUserSettings = (countryCode = 'US') =>
    baseFetch(`user/Settings?geoCountryIso=${countryCode}`);

export const updateUserSettings = update => doFetchWithOptions('user/settings', {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(update),
});

export const deleteUserFavorite = id => doFetchWithOptions(`favorites/${id}`, {
  method: 'DELETE',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchPaymentWarnings = () => ([]);



// WEBPACK FOOTER //
// ./src/common/api/user.js